import { designSystem } from '@/styles/styles';

export const getMultiplierBackgroundColor = (hasBoostedPicks?: boolean, hasValidMultiplier?: boolean): string => {
    if (hasBoostedPicks && hasValidMultiplier) {
        return designSystem.colors.boosted;
    }

    return designSystem.colors.gray1;
};
